import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { DateTimePicker } from '@material-ui/pickers';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import RichTextEditor from 'app/components/rte/RichTextEditor';

const useStyles = makeStyles(theme => ({
    section: {
        marginBottom: theme.spacing(3)
    },
    formContainer: {
        overflowY: 'scroll',
        height: '100%',
        padding: theme.spacing(3)
    },
    mobileContainer: {
        height: '100%',
        padding: theme.spacing(3)
    },
    marginTop: {
        marginTop: theme.spacing(3)
    },
    image: {
        maxHeight: 300,
        maxWidth: 300,
        height: 'auto',
        width: '100%'
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: theme.spacing(6)
    },
    height: {
        height: '100%'
    },
    opacity: {
        opacity: 0.5
    },
    editor: {
        marginTop: theme.spacing(3),
        '& .public-DraftEditor-content': {
            minHeight: 400,
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
        }
    },
}));

export default function EventDescription(props) {

    const {
        newEvent,
        editorState,
        setEditorState
    } = props;

    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid container direction="row" className={newEvent ? classes.height : null}>
            {!newEvent ? null : isMobile ? null :
                <Grid item xs className={classes.height}>
                    <div className={classes.imageContainer}>
                        <img className={classes.image} src='/images/step-proposal.png' alt="event-graphic" />
                    </div>
                </Grid>
            }
            <Grid item xs={isMobile ? 12 : newEvent ? 7 : 12} className={isMobile ? classes.mobileContainer : newEvent ? classes.formContainer : null}>
                <Typography variant="h6" gutterBottom>
                    Full Event Description
                </Typography>
                <RichTextEditor
                    active
                    editorState={editorState}
                    setEditorState={setEditorState}
                    options={{editor_min_height: 300, editor_border: true }}
                />
            </Grid>
        </Grid>
    )
}
